import { Button, Drawer, Stack, Tab } from '@material-ui/core';
import { useState } from 'react';
import History from './History';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getPatientRequests } from 'src/services/employee.service';
import PreviousRequestPreview from './PreviousRequestPreview';
import HistoryIcon from '@mui/icons-material/History';
import RequestsGrid from 'src/components/RequestsGrid/RequestsGrid';
import { userAtom } from 'src/atoms/user';
import { useRecoilValue } from 'recoil';

function HistoryDrawer({ id }) {
  const user = useRecoilValue(userAtom);
  const [open, setOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const toggleTab = () => {
    setSelectedTab((selectedTab + 1) % 2);
  };
  const [showGrid, setShowGrid] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [saved, setSaved] = useState(true);
  const onRowClick = (id) => {
    setShowGrid(false);
    setSelectedRequest(id);
  };
  return (
    <>
      <Stack direction={'column'} justifyContent={'center'}>
        <Button
          onClick={() => setOpen(true)}
          variant="contained"
          style={{ width: '100%', fontSize: 'large', padding: '5px 15px' }}
        >
          <HistoryIcon style={{ marginRight: '5px' }} />
          History
        </Button>
        {!saved ? (
          <center>
            <p style={{ color: 'red', fontSize: '12px', marginTop: '8px', fontWeight: 'bold' }}>
              You have unsaved changes
            </p>
          </center>
        ) : null}
      </Stack>
      <Drawer
        onClose={() => setOpen(false)}
        open={open}
        anchor="right"
        keepMounted={true}
        PaperProps={{
          sx: { width: 1200 }
        }}
      >
        <TabContext value={user.role === 'DOCTOR' ? selectedTab : 1}>
          <TabList
            onChange={toggleTab}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            {user.role === 'DOCTOR' && (
              <Tab label="History" value={0} style={{ textAlign: 'center', minWidth: 600 }} />
            )}
            <Tab
              label="Previous Requests"
              value={1}
              style={{
                textAlign: 'center',
                width: user.role === 'ADMIN' ? 1200 : 600,
                minWidth: user.role === 'ADMIN' ? 1200 : 600
              }}
            />
          </TabList>
          <TabPanel value={0} style={{ overflow: 'hidden', flex: 1, padding: 0 }}>
            <History id={id} saved={saved} setSaved={setSaved} />
          </TabPanel>
          <TabPanel value={1} style={{ overflowY: 'hidden', paddingBottom: '4%', paddingRight: 0 }}>
            {showGrid ? (
              <RequestsGrid
                onRowClick={onRowClick}
                queryId={['previousRequests', id]}
                query={({ params }) => getPatientRequests({ id: id, params: params })}
              />
            ) : (
              <PreviousRequestPreview setShowGrid={setShowGrid} reqId={selectedRequest} />
            )}
          </TabPanel>
        </TabContext>
      </Drawer>
    </>
  );
}
export default HistoryDrawer;
